export default "__VITE_ASSET__$xsFIha4__"